exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-background[data-v-3e2c9f38]{background-color:silver\n}\n.cropper-logo[data-v-3e2c9f38]{max-height:350px;width:100%;background-color:#ddd\n}", ""]);

// exports
